"use client";

import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useAuth } from "@/lib/hooks/useAuth";
import {
  ensureFirebaseAuthFromNextAuth,
  resolveNextAuthUserId,
} from "@/lib/auth/ensureFirebaseAuthFromNextAuth";

/** NextAuth(구글) 로그인 시 Firebase Auth 연동만 수행. 프로필은 서버 API에서 처리 */
export default function NextAuthToFirebaseSync() {
  const { data: session, status } = useSession();
  const { user: firebaseUser } = useAuth();
  const processedUserIdsRef = useRef(new Set<string>());

  useEffect(() => {
    const syncGoogleUser = async () => {
      if (status !== "authenticated" || !session?.user || firebaseUser) {
        return;
      }

      const userId = resolveNextAuthUserId(session);
      if (!userId || processedUserIdsRef.current.has(userId)) {
        return;
      }

      processedUserIdsRef.current.add(userId);

      try {
        await ensureFirebaseAuthFromNextAuth(userId);
      } catch (error) {
        console.error("❌ NextAuth → Firebase 연동 실패:", error);
        processedUserIdsRef.current.delete(userId);
      }
    };

    void syncGoogleUser();
  }, [session, firebaseUser, status]);

  return null;
}
